/**
 * ActivityLevelStep.validation.js
 *
 * Pure function, no React — testable on its own and reusable if the
 * Summary screen (Screen 13) ever needs to re-validate before submit.
 * Mirrors LifestyleStep.validation.js's shape: ActivityLevelStep only
 * consumes `isValid` (to drive AssessmentStepShell's `nextDisabled`) —
 * `errors` is returned too in case a future screen wants field-level
 * messaging.
 */

export function validateActivity(data) {
  const errors = {};

  if (!data.activityTier) {
    errors.activityTier = "Please select your activity level.";
  }

  // Frequency only matters once at least one exercise type is picked — a
  // Sedentary user with no structured exercise can legitimately leave
  // exerciseTypes empty and skip straight past Days/week and Minutes/day.
  const hasExercise = Array.isArray(data.exerciseTypes) && data.exerciseTypes.length > 0;
  if (hasExercise) {
    if (!data.daysPerWeek) {
      errors.daysPerWeek = "Please set how many days a week you exercise.";
    }
    if (!data.minutesPerDay) {
      errors.minutesPerDay = "Please set how many minutes a day you exercise.";
    }
  }

  return { isValid: Object.keys(errors).length === 0, errors };
}